var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',[_c('b-card',{staticClass:"my-3 mb-2"},[_c('div',{staticClass:"mb-3"},_vm._l((_vm.emails),function(email){return _c('span',{key:email},[_vm._v(_vm._s(email)+"; ")])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }